import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import _ from 'lodash';
import { AppModule } from './app/app.module';

import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { environment } from './environments/environment';

if (environment.production) enableProdMode();

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(_ => console.log('Bootstrapped'))
  .catch(err => console.log(err));

// Call the element loader after the platform has been bootstrapped
defineCustomElements(window);
